/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:88ae5f42-811f-4096-b476-c39af0383544",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_B8icsyFo9",
    "aws_user_pools_web_client_id": "66rll53e2btgcfspv193r316pf",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "carter-center-dashboard-data-publica8566-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
